import React, { useContext, useCallback } from 'react';
import { arrayOf, shape } from 'prop-types';
import classnames from 'classnames';
import MediaAction from '../../../media/media-action';
import HSAdditionalInformation from '../hs-additional-information';
import HSHighlightedFeaturesList from '../hs-highlighted-features-list';
import StaticPropsContext from '../../../context/static-props';

const namespace = 'ui-vpp-highlighted-specs__features';

const HSHighlightedFeatures = ({
  features,
  action = null,
  additional_information: additionalInformation = undefined,
}) => {
  const { deviceType } = useContext(StaticPropsContext);
  const isDesktop = deviceType === 'desktop';

  // eslint-disable-next-line consistent-return
  const onClickHandler = useCallback((e, isKeyboardNav) => {
    e.preventDefault();

    const seeMoreButtonSpecs = document.getElementById('see-more-button-hs-features');
    const specs = document.getElementById('highlighted_specs_attrs');

    if (seeMoreButtonSpecs && seeMoreButtonSpecs instanceof HTMLElement) {
      seeMoreButtonSpecs.click();
    }

    if (specs && specs instanceof HTMLElement) {
      specs.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (isKeyboardNav) {
        const timeoutId = setTimeout(() => {
          specs.focus();
        }, 500);

        return () => clearTimeout(timeoutId);
      }
    }
  }, []);

  const onKeyDownHandler = useCallback(e => {
    if (e.key === 'Enter' || e.key === ' ') {
      const isKeyboardNav = true;
      onClickHandler(e, isKeyboardNav);
    }
  }, [onClickHandler]);

  return (
    <div
      className={classnames(namespace, {
        'ui-pdp-with--separator': !isDesktop,
      })}
    >
      <HSHighlightedFeaturesList features={features} />
      {additionalInformation && <HSAdditionalInformation namespace={namespace} label={additionalInformation} />}
      {action && isDesktop && (
        <MediaAction
          id="see-more-button-hs-features"
          target="#highlighted_specs_attrs"
          className={`${namespace}-action`}
          title={action.label.text}
          label={action.label}
          track={action.track}
          data-testid="highlighted-features-action"
          onClick={onClickHandler}
          onKeyDown={onKeyDownHandler}
        />
      )}
    </div>
  );
};

HSHighlightedFeatures.propTypes = {
  action: shape({}),
  features: arrayOf(shape({}).isRequired).isRequired,
  additional_information: shape({}),
};

export default HSHighlightedFeatures;
